import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AuthService } from '../../authentication/auth.service';
import { ApiServiceBase } from '../../base/api-service-base';
import { ActivityPriorityReferenceModel } from '../../models/reference-model/reference-general-model/activity-priority-reference.model';

@Injectable({
  providedIn: 'root'
})
export class ActivityPriorityReferenceService extends ApiServiceBase {
  private readonly PATH = "/system/ActivityPriorityReference";
  
  constructor(httpClient: HttpClient,
    authService: AuthService) {
    super(httpClient, authService);
  }

  public getActivityPriorityReferences(): Observable<ActivityPriorityReferenceModel[]> {
    return this.httpGet<ActivityPriorityReferenceModel[]>(this.PATH, null)
      .pipe(
        map(response => response.body)
      );
  }
}
